import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Room } from '@weblite/ts-action/room'
import { nonClientRoomsStorage, roomSyncStatusView } from '$logic/room/storage'
import { RootState } from '$setup/redux'
import { getRoom } from './service'

const getRoomView = (roomId: string) => (state: RootState): Room =>
  state.main.rooms[roomId]

const getRoomAttributeView = <T extends keyof Room>(
  attr: T,
  roomId: string,
) => (state: RootState): Room[T] => state.main.rooms[roomId]?.[attr]

const getRoomsView = (state: RootState): Record<string, Room> =>
  state.main.rooms

// TODO: Refactor components using it after final implementation
export function useRoom(roomId: string = ''): Room | undefined {
  const [fetchedRoom, setFetchedRoom] = useState<Room>()
  const room = useSelector(getRoomView(roomId))

  useEffect(() => {
    if (!room)
      getRoom(roomId).then(innerRoom => setFetchedRoom(innerRoom || undefined))
  }, [roomId, room])

  return room || fetchedRoom || nonClientRoomsStorage.get(roomId)
}

export const useRoomAttribute = <T extends keyof Room>(
  attr: T,
  roomId: string,
): Room[T] => {
  const [fetchedRoomAttr, setFetchedRoomAttr] = useState<Room[T]>()
  const roomAttr = useSelector(getRoomAttributeView(attr, roomId))

  useEffect(() => {
    if (!roomAttr)
      getRoom(roomId).then(room => setFetchedRoomAttr(room?.[attr]))
  }, [roomId, roomAttr, attr])

  return (
    roomAttr || fetchedRoomAttr || nonClientRoomsStorage.get(roomId)?.[attr]
  )
}

export function useRooms() {
  return useSelector(getRoomsView)
}

export function useRoomSyncStatus() {
  return useSelector(roomSyncStatusView) || { atLeastOnce: false }
}
